import React from 'react';
import ExpandAllIcon from '@mui/icons-material/UnfoldMore';
import { IconButton } from '@mui/material';

interface ExpandAllButtonProps {
  readonly expandAll: (rowIds: readonly string[]) => void;
  readonly allExpandableRowIds: readonly string[];
}

export function ExpandAllButton(props: ExpandAllButtonProps) {
  const { allExpandableRowIds, expandAll } = props;

  return (
    <IconButton
      onClick={(event) => {
        event.stopPropagation();
        expandAll(allExpandableRowIds);
      }}
    >
      <ExpandAllIcon />
    </IconButton>
  );
}
